var Acr = Acr || {};

Acr.StickySideNav = function () {


  var $stickySideNav;
  var $stickySideNavList;
  var $backToTopButton;
  var $openChatButton;
  var $chatBotTitle;
  const backToTopButton = '.js-back-to-top-button';
  const stickySideNavList = '.js-sticky-side-nav-list';
  const openChatButton = '.js-open-chat-button';
  const chatBotTitle = '.js-chatbot-title';
  const stickySideNavItemVisible = 'sticky-side-nav__item--visible';
  const stickySideNavItemExpanded = 'sticky-side-nav__item--expanded';
  const stickySideNavListExpanded = 'sticky-side-nav__list--expanded';

  function openChat() {
    event.preventDefault();
    if (typeof carlaBot !== 'undefined') {
      $stickySideNav.addClass('hidden');
      carlaBot.openChat();
      setTimeout(function () {
        $stickySideNav.removeClass('hidden');
      }, 1500);
    }
  }

  function backToTop(event) {
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, '300');
    $backToTopButton.removeClass(stickySideNavItemVisible);
    $backToTopButton.removeClass(stickySideNavItemExpanded);
  }

  function eventHandler(event) {
    if (event.type === 'touchend' && !$stickySideNavList.hasClass(stickySideNavListExpanded)) {
      event.preventDefault();
      $stickySideNavList.addClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'true');
      $(document).on('touchend', hideStickySideNavList);
    } else if ($(event.currentTarget.parentElement).is($openChatButton)) {
      openChat();
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'false');
      $(document).off('click touchend', hideStickySideNavList);
    } else {
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'false');
      $(document).off('click touchend', hideStickySideNavList);
    }
  }

  function onScroll() {
    if ($stickySideNavList.hasClass(stickySideNavListExpanded)) {
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList.setAttribute[0]('aria-expanded', 'false');
      $(document).off('click', hideStickySideNavList);
    }

    if (!$backToTopButton.hasClass(stickySideNavItemVisible)) {
      $backToTopButton.addClass(stickySideNavItemVisible);
    }

    if (($backToTopButton.hasClass(stickySideNavItemVisible) || $backToTopButton.hasClass(stickySideNavItemExpanded)) && $(document).scrollTop() === 0) {
      $backToTopButton.removeClass(stickySideNavItemExpanded);
      $backToTopButton.removeClass(stickySideNavItemVisible);
    }
  }

  function hideStickySideNavList() {
    if (!$(event.target).parents().is($stickySideNavList)) {
      $stickySideNavList.removeClass(stickySideNavListExpanded);
      $stickySideNavList[0].setAttribute('aria-expanded', 'false');
      $(document).off('click touchend', hideStickySideNavList);
    }
  }

  function initSelectors(element) {
    $stickySideNav = $(element);
    $stickySideNavList = $stickySideNav.find(stickySideNavList);
    $backToTopButton = $stickySideNav.find(backToTopButton);
    $openChatButton = $stickySideNav.find(openChatButton);
    $chatBotTitle = $stickySideNav.find(chatBotTitle);
  }

  function bindEvents() {
    $stickySideNavList.hover(
      function () {
        $(this).addClass(stickySideNavListExpanded);
        $(this)[0].setAttribute('aria-expanded', 'true');
        $(document).off('click', hideStickySideNavList);
        $(document).on('click', hideStickySideNavList);
      },
    );

    $(window).scroll(function () {
      onScroll();
    });

    $stickySideNavList.find('a').on('click touchend', eventHandler);
    $backToTopButton.find('a').on('click touchend', backToTop);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
    $stickySideNav.css('display', 'flex');
  }

  return {
    init: init,
  };
};
